import React from 'react';
import { Box, Button, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { getRuntimeConfig } from '../config/runtimeConfig';

export function PlayerLayout({ children }) {
  const permissions = getRuntimeConfig().permissions;
  const canAccessAdmin = Boolean(permissions?.isAdmin || permissions?.canEdit);

  return (
    <Box sx={{ py: 3 }}>
      {canAccessAdmin && (
        <Stack direction="row" justifyContent="flex-end" sx={{ mb: 2 }}>
          <Button component={RouterLink} to="/admin/dashboard" variant="outlined" size="small">
            Admin
          </Button>
        </Stack>
      )}
      {children}
    </Box>
  );
}
